<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-product-booking modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>วันที่นัดหมาย {{ appMoment(bookingData.appointmentDate).format('DD.MM.Y') }}</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="booking-status" v-if="bookingData.bookingStatus === 'accept'">รับบริการแล้ว</div>
                        <br />
                        <div class="booking-data">
                            <div class="item">
                                <label><b-icon icon="person-circle"></b-icon></label>
                                <span>{{ bookingData.customerName }}</span>
                            </div>
                            <div class="item">
                                <label><b-icon icon="telephone-fill"></b-icon></label>
                                <span>{{ bookingData.contactTel }}</span>
                            </div>
                            <div class="item">
                                <label><b-icon icon="card-text"></b-icon></label>
                                <span>{{ bookingData.licenseNumber }}</span>
                            </div>
                        </div>

                        <perfect-scrollbar>
                            <table>
                                <thead>
                                    <tr>
                                        <th>สินค้า</th>
                                        <th class="text-center" v-if="bookingData.bookingStatus !== 'accept'">สถานะ</th>
                                        <th class="text-center">จำนวน</th>
                                        <th class="action-column" v-if="bookingData.bookingStatus !== 'accept'"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in bookingData.stockList" :key="index">
                                        <td>{{ item.productData.name }}</td>
                                        <td class="text-center" v-if="bookingData.bookingStatus !== 'accept'">
                                            <span class="stock no-stock" v-if="!item.stockStatus">ของไม่พอ</span>
                                            <span class="stock available" v-if="item.stockStatus">มีของแล้ว</span>
                                        </td>
                                        <td class="text-center">{{ item.quantity }}</td>
                                        <td class="text-center" v-if="bookingData.bookingStatus !== 'accept'">
                                            <button class="btn btn-sm btn-blue text-nowrap" @click="openModalStock(item.inventoryKey)">จัดสต๊อค</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </perfect-scrollbar>

                        <div class="mt-4 text-center">
                            <button class="btn btn-grey-outline" @click="hide()">ปิดหน้าต่าง</button>
                        </div>
                    </div>
                </div>
            </div>

            <inventory-modal-stock
                :isDisplay="isShowModalStock"
                :contentData="selectedInventoryData"
                @stockUpdate="reloadStockData()"
                @hide="closeModalStock()">
            </inventory-modal-stock>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import moment from 'moment';
import InventoryModalStock from '@/components/inventory/ModalStock';
import DBInventory from '@/database/Inventory';
import DBStock from '@/database/Stock';

export default {
    components: {
        InventoryModalStock
    },
    data() {
        return {
            isActive: false,
            appMoment: moment,
            isShowModalStock: false,
            selectedInventoryData: null
        };
    },
    props: {
        isDisplay: Boolean,
        bookingData: Object
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
        }
    },
    methods: {
        hide() {
            this.$emit('hide');
        },
        async openModalStock(key) {
            await this.loadInventoryDetail(key);
            this.isShowModalStock = true;
        },
        closeModalStock() {
            this.isShowModalStock = false;
        },
        reloadStockData() {
            this.closeModalStock();
            this.$emit('reloadStockData');
        },
        async loadInventoryDetail(key) {
            const loader = this.$AppUtility.renderLoadBackdrop();

            // Load Inventory Data
            const inventory = await DBInventory.getDetail(key);
            const stock = await DBStock.getDetail(key);

            inventory['stockData'] = {
                dots: stock.dots,
                reserve: stock.reserve
            };

            this.selectedInventoryData = inventory;
            
            // Done Loading
            loader.hide();
        },
        async mapInventoryData(data) {
            return {
                key: data.key,
                productData: data.productData,
                inventoryData: data.inventoryData,
                stockData: data.stockData
            };
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-product-booking {
    max-width: 800px;

    .booking-status {
        display: inline-block;
        margin-bottom: 10px;
        font-size: 11px;
        padding: 2px 5px;
        color: #fff;
        background-color: #1e7b5d;
    }

    .booking-data {
        font-size: 13px;
        display: flex;
        margin-bottom: 15px;

        .item {
            margin-right: 20px;

            .bi {
                margin-right: 8px;
                opacity: 0.3;
            }
        }
    }

    table {
        font-size: 14px;

        td {
            vertical-align: top;

            span {
                &.stock {
                    opacity: 1;
                    font-size: 11px;
                    padding: 2px 5px;
                    display: inline-block;

                    &.done {
                        background-color: #595b77;
                    }

                    &.available {
                        background-color: #1e7b5d;
                    }

                    &.no-stock {
                        background-color: #cc0000;
                    }
                }
            }
        }
    }
}
</style>